import { Controller } from "stimulus";
import { placeBeside } from "../../training_grooming_calendar/pointer";
import { openDisclosure, closeOverlay } from "../../training_grooming_calendar/overlay";

export default class extends Controller {
  static targets = ["container"];

  show(event) {
    const schedule = event.currentTarget;
    const card = schedule.querySelector(".tg-schedule-card");
    if (!card) return;
    this.hide();
    this.schedule = schedule;
    this.card = card;
    schedule.classList.add("tg-schedule-hot");
    this.containerTarget.appendChild(card);
    card.classList.add("open");
    const spot = placeBeside({ anchor: schedule.getBoundingClientRect(), width: card.offsetWidth, height: card.offsetHeight, viewport: { width: window.innerWidth, height: window.innerHeight } });
    card.style.left = `${spot.left}px`;
    card.style.top = `${spot.top}px`;
    this.scroller = schedule.closest(".tg-day-scroll");
    this.handleScroll = () => this.hide();
    if (this.scroller) this.scroller.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  hide() {
    if (this.handleScroll) {
      if (this.scroller) this.scroller.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("scroll", this.handleScroll);
      this.handleScroll = null;
      this.scroller = null;
    }
    if (!this.schedule) return;
    this.schedule.classList.remove("tg-schedule-hot");
    this.card.classList.remove("open");
    this.schedule.appendChild(this.card);
    this.schedule = null;
    this.card = null;
  }

  open(event) {
    const pill = event.currentTarget;
    const sheet = this.containerTarget.querySelector(`[data-schedule-sheet="${pill.dataset.scheduleId}"]`);
    if (!sheet) return;
    openDisclosure({ element: sheet, trigger: pill, root: this.element, sheet: true, triggerClass: "tg-m-sched-open" });
    const close = sheet.querySelector(".tg-sheet-close");
    if (close) close.focus({ preventScroll: true });
  }

  close() {
    closeOverlay();
  }

  reset() {
    this.hide();
  }
}
